import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _79fb2f27 = () => interopDefault(import('../../../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _821f8c0c = () => interopDefault(import('../../../pages/account-deletion/index.vue' /* webpackChunkName: "pages/account-deletion/index" */))
const _73427179 = () => interopDefault(import('../../../pages/challenges.vue' /* webpackChunkName: "pages/challenges" */))
const _1f70fe4c = () => interopDefault(import('../../../pages/currency.vue' /* webpackChunkName: "pages/currency" */))
const _9180a390 = () => interopDefault(import('../../../pages/endorsement/index.vue' /* webpackChunkName: "pages/endorsement/index" */))
const _7ddec2da = () => interopDefault(import('../../../pages/explore.vue' /* webpackChunkName: "pages/explore" */))
const _050b01f4 = () => interopDefault(import('../../../pages/features.vue' /* webpackChunkName: "pages/features" */))
const _cc0e2f32 = () => interopDefault(import('../../../pages/feed.vue' /* webpackChunkName: "pages/feed" */))
const _0c622062 = () => interopDefault(import('../../../pages/forgot-password/index.vue' /* webpackChunkName: "pages/forgot-password/index" */))
const _698b26f7 = () => interopDefault(import('../../../pages/logbook/index.vue' /* webpackChunkName: "pages/logbook/index" */))
const _b9774720 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _12583a13 = () => interopDefault(import('../../../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _d18385b8 = () => interopDefault(import('../../../pages/my_endorsement.vue' /* webpackChunkName: "pages/my_endorsement" */))
const _19f46922 = () => interopDefault(import('../../../pages/notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _f9bb0fc0 = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _7bb76973 = () => interopDefault(import('../../../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _2acb2bef = () => interopDefault(import('../../../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _839a2e18 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _cc7bda16 = () => interopDefault(import('../../../pages/sign_endorsement.vue' /* webpackChunkName: "pages/sign_endorsement" */))
const _fc87530e = () => interopDefault(import('../../../pages/sign_flight.vue' /* webpackChunkName: "pages/sign_flight" */))
const _650dc468 = () => interopDefault(import('../../../pages/sign_ground_time.vue' /* webpackChunkName: "pages/sign_ground_time" */))
const _37587b8b = () => interopDefault(import('../../../pages/sign_simulator.vue' /* webpackChunkName: "pages/sign_simulator" */))
const _1ae181b6 = () => interopDefault(import('../../../pages/suggestions.vue' /* webpackChunkName: "pages/suggestions" */))
const _4e177e8e = () => interopDefault(import('../../../pages/terms-of-service.vue' /* webpackChunkName: "pages/terms-of-service" */))
const _65c0ee82 = () => interopDefault(import('../../../pages/account-deletion/cancel.vue' /* webpackChunkName: "pages/account-deletion/cancel" */))
const _719ca630 = () => interopDefault(import('../../../pages/account-deletion/confirm.vue' /* webpackChunkName: "pages/account-deletion/confirm" */))
const _e36220ca = () => interopDefault(import('../../../pages/endorsement/give.vue' /* webpackChunkName: "pages/endorsement/give" */))
const _197a95f5 = () => interopDefault(import('../../../pages/endorsement/request.vue' /* webpackChunkName: "pages/endorsement/request" */))
const _3367b650 = () => interopDefault(import('../../../pages/forgot-password/callback.vue' /* webpackChunkName: "pages/forgot-password/callback" */))
const _758b7d06 = () => interopDefault(import('../../../pages/forgot-password/confirm.vue' /* webpackChunkName: "pages/forgot-password/confirm" */))
const _1c9e58d0 = () => interopDefault(import('../../../pages/logbook/import.vue' /* webpackChunkName: "pages/logbook/import" */))
const _7da7028d = () => interopDefault(import('../../../pages/profile/no-post.vue' /* webpackChunkName: "pages/profile/no-post" */))
const _602ff138 = () => interopDefault(import('../../../pages/profile/private.vue' /* webpackChunkName: "pages/profile/private" */))
const _5f24f4b8 = () => interopDefault(import('../../../pages/register/callback.vue' /* webpackChunkName: "pages/register/callback" */))
const _c4dc6252 = () => interopDefault(import('../../../pages/register/certification.vue' /* webpackChunkName: "pages/register/certification" */))
const _afd014c6 = () => interopDefault(import('../../../pages/register/confirm.vue' /* webpackChunkName: "pages/register/confirm" */))
const _8774e55e = () => interopDefault(import('../../../pages/register/fill-data.vue' /* webpackChunkName: "pages/register/fill-data" */))
const _17dfabe4 = () => interopDefault(import('../../../pages/register/verification.vue' /* webpackChunkName: "pages/register/verification" */))
const _c3f93e54 = () => interopDefault(import('../../../pages/search/airports.vue' /* webpackChunkName: "pages/search/airports" */))
const _2ac2105d = () => interopDefault(import('../../../pages/search/people.vue' /* webpackChunkName: "pages/search/people" */))
const _c42d14f6 = () => interopDefault(import('../../../pages/settings/notifications.vue' /* webpackChunkName: "pages/settings/notifications" */))
const _185cd68e = () => interopDefault(import('../../../pages/settings/password.vue' /* webpackChunkName: "pages/settings/password" */))
const _0eeadbe5 = () => interopDefault(import('../../../pages/settings/privacy.vue' /* webpackChunkName: "pages/settings/privacy" */))
const _80336cf4 = () => interopDefault(import('../../../pages/settings/profile.vue' /* webpackChunkName: "pages/settings/profile" */))
const _73d5ba36 = () => interopDefault(import('../../../pages/posts/simulator/edit/_id.vue' /* webpackChunkName: "pages/posts/simulator/edit/_id" */))
const _e22c6dc6 = () => interopDefault(import('../../../pages/location/price-report/_report.vue' /* webpackChunkName: "pages/location/price-report/_report" */))
const _23bf7a0c = () => interopDefault(import('../../../pages/posts/edit/_id.vue' /* webpackChunkName: "pages/posts/edit/_id" */))
const _0e6874be = () => interopDefault(import('../../../pages/public/posts/_id.vue' /* webpackChunkName: "pages/public/posts/_id" */))
const _24ffa6b7 = () => interopDefault(import('../../../pages/public/profile/_id.vue' /* webpackChunkName: "pages/public/profile/_id" */))
const _985e8486 = () => interopDefault(import('../../../pages/airport/_id.vue' /* webpackChunkName: "pages/airport/_id" */))
const _7f039d29 = () => interopDefault(import('../../../pages/location/_id.vue' /* webpackChunkName: "pages/location/_id" */))
const _23e37485 = () => interopDefault(import('../../../pages/posts/_id.vue' /* webpackChunkName: "pages/posts/_id" */))
const _2e31a6ca = () => interopDefault(import('../../../pages/profile/_id.vue' /* webpackChunkName: "pages/profile/_id" */))
const _ed233ad6 = () => interopDefault(import('../../../pages/slider/_id.vue' /* webpackChunkName: "pages/slider/_id" */))
const _4cc68d4e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _79fb2f27,
    name: "about-us"
  }, {
    path: "/account-deletion",
    component: _821f8c0c,
    name: "account-deletion"
  }, {
    path: "/challenges",
    component: _73427179,
    name: "challenges"
  }, {
    path: "/currency",
    component: _1f70fe4c,
    name: "currency"
  }, {
    path: "/endorsement",
    component: _9180a390,
    name: "endorsement"
  }, {
    path: "/explore",
    component: _7ddec2da,
    name: "explore"
  }, {
    path: "/features",
    component: _050b01f4,
    name: "features"
  }, {
    path: "/feed",
    component: _cc0e2f32,
    name: "feed"
  }, {
    path: "/forgot-password",
    component: _0c622062,
    name: "forgot-password"
  }, {
    path: "/logbook",
    component: _698b26f7,
    name: "logbook"
  }, {
    path: "/login",
    component: _b9774720,
    name: "login"
  }, {
    path: "/logout",
    component: _12583a13,
    name: "logout"
  }, {
    path: "/my_endorsement",
    component: _d18385b8,
    name: "my_endorsement"
  }, {
    path: "/notifications",
    component: _19f46922,
    name: "notifications"
  }, {
    path: "/privacy-policy",
    component: _f9bb0fc0,
    name: "privacy-policy"
  }, {
    path: "/profile",
    component: _7bb76973,
    name: "profile"
  }, {
    path: "/register",
    component: _2acb2bef,
    name: "register"
  }, {
    path: "/search",
    component: _839a2e18,
    name: "search"
  }, {
    path: "/sign_endorsement",
    component: _cc7bda16,
    name: "sign_endorsement"
  }, {
    path: "/sign_flight",
    component: _fc87530e,
    name: "sign_flight"
  }, {
    path: "/sign_ground_time",
    component: _650dc468,
    name: "sign_ground_time"
  }, {
    path: "/sign_simulator",
    component: _37587b8b,
    name: "sign_simulator"
  }, {
    path: "/suggestions",
    component: _1ae181b6,
    name: "suggestions"
  }, {
    path: "/terms-of-service",
    component: _4e177e8e,
    name: "terms-of-service"
  }, {
    path: "/account-deletion/cancel",
    component: _65c0ee82,
    name: "account-deletion-cancel"
  }, {
    path: "/account-deletion/confirm",
    component: _719ca630,
    name: "account-deletion-confirm"
  }, {
    path: "/endorsement/give",
    component: _e36220ca,
    name: "endorsement-give"
  }, {
    path: "/endorsement/request",
    component: _197a95f5,
    name: "endorsement-request"
  }, {
    path: "/forgot-password/callback",
    component: _3367b650,
    name: "forgot-password-callback"
  }, {
    path: "/forgot-password/confirm",
    component: _758b7d06,
    name: "forgot-password-confirm"
  }, {
    path: "/logbook/import",
    component: _1c9e58d0,
    name: "logbook-import"
  }, {
    path: "/profile/no-post",
    component: _7da7028d,
    name: "profile-no-post"
  }, {
    path: "/profile/private",
    component: _602ff138,
    name: "profile-private"
  }, {
    path: "/register/callback",
    component: _5f24f4b8,
    name: "register-callback"
  }, {
    path: "/register/certification",
    component: _c4dc6252,
    name: "register-certification"
  }, {
    path: "/register/confirm",
    component: _afd014c6,
    name: "register-confirm"
  }, {
    path: "/register/fill-data",
    component: _8774e55e,
    name: "register-fill-data"
  }, {
    path: "/register/verification",
    component: _17dfabe4,
    name: "register-verification"
  }, {
    path: "/search/airports",
    component: _c3f93e54,
    name: "search-airports"
  }, {
    path: "/search/people",
    component: _2ac2105d,
    name: "search-people"
  }, {
    path: "/settings/notifications",
    component: _c42d14f6,
    name: "settings-notifications"
  }, {
    path: "/settings/password",
    component: _185cd68e,
    name: "settings-password"
  }, {
    path: "/settings/privacy",
    component: _0eeadbe5,
    name: "settings-privacy"
  }, {
    path: "/settings/profile",
    component: _80336cf4,
    name: "settings-profile"
  }, {
    path: "/posts/simulator/edit/:id?",
    component: _73d5ba36,
    name: "posts-simulator-edit-id"
  }, {
    path: "/location/price-report/:report?",
    component: _e22c6dc6,
    name: "location-price-report-report"
  }, {
    path: "/posts/edit/:id?",
    component: _23bf7a0c,
    name: "posts-edit-id"
  }, {
    path: "/public/posts/:id?",
    component: _0e6874be,
    name: "public-posts-id"
  }, {
    path: "/public/profile/:id?",
    component: _24ffa6b7,
    name: "public-profile-id"
  }, {
    path: "/airport/:id?",
    component: _985e8486,
    name: "airport-id"
  }, {
    path: "/location/:id?",
    component: _7f039d29,
    name: "location-id"
  }, {
    path: "/posts/:id?",
    component: _23e37485,
    name: "posts-id"
  }, {
    path: "/profile/:id",
    component: _2e31a6ca,
    name: "profile-id"
  }, {
    path: "/slider/:id?",
    component: _ed233ad6,
    name: "slider-id"
  }, {
    path: "/",
    component: _4cc68d4e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
